export const ASTI_MSG_SET_COMPANY = 'asti-msg-set-company';
export const ASTI_MSG_SHOW_ONYO_ICON = 'asti-msg-show-onyo-icon';
export const ASTI_MSG_SHOW_KEYBOARD = 'asti-msg-show-keyboard';

export interface AstilectronMessage {
  type: string;
  payload: any;
}
